<!--
 * @Description: 
 * @Author: pliybird
 * @Date: 2023-05-25 14:11:17
 * @LastEditTime: 2023-06-26 14:41:48
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<!--
 * @Description: 零售快消行业
-->
<template>
  <Layout>
    <!-- banner -->
    <div>
      <div class="slider-area slider-style-2 variation-3 height-720 bg_image bg_image_fixed" :style="{
        'background-image': `url(${require(`@/assets/images/IndustrySolution/banner/industry-banner-04.png`)})`,
      }">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="inner text-center">
                <h2 class="title" data-aos="fade-up" data-aos-delay="100">
                  {{ $t("solution.retail.header.title01") }}
                </h2>
                <h4 class="subtitle color-white mb--30" data-aos="fade-up" data-aos-delay="200">
                  {{ $t("solution.retail.header.title02") }}
                </h4>
                <p class="col-12 offset-lg-3 col-lg-6 description color-white" data-aos="fade-up" data-aos-delay="300">
                  {{ $t("solution.retail.header.description") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rn-section-gapBottom industry-banner">
        <div class="container">
          <div class="row">
            <div class="col-lg-10 offset-lg-1">
              <div class="row row--0 align-items-center mt_dec--30 wrapper">
                <div class="col-lg-12 mt_sm--30 mb_sm--30">
                  <div class="content row align-items-center">
                    <div class="col-12 col-lg-2 col-md-2 text-center">
                      <img class="icon" :src="require('@/assets/images/IndustrySolution/banner/industry-banner-icon1.png')
                        " alt="" />
                    </div>
                    <div class="inner col-12 col-lg-10 col-md-10">
                      <h4 class="title mb--10">
                        {{ $t("solution.retail.header.card.title") }}
                      </h4>
                      <div style="display: flex">
                        <div style="flex: 1">
                          <p class="description mb--0 w-600">
                            {{
                              $t(
                                "solution.retail.header.card.description01.title"
                              )
                            }}
                          </p>
                          <div style="border-right: 1px solid rgba(9, 15, 33, 0.2);padding-right: 50px;">
                            <p class="description mb--0" style="line-height: 2">
                              {{
                                $t(
                                  "solution.retail.header.card.description01.desc1"
                                )
                              }}
                              <br />
                              {{
                                $t(
                                  "solution.retail.header.card.description01.desc2"
                                )
                              }}
                              <br />
                              {{
                                $t(
                                  "solution.retail.header.card.description01.desc3"
                                )
                              }}
                              <br />
                              {{
                                $t(
                                  "solution.retail.header.card.description01.desc4"
                                )
                              }}
                            </p>
                          </div>
                        </div>
                        <div style="flex: 3; padding-left: 50px">
                          <p class="description mb--0 w-600">
                            {{
                              $t(
                                "solution.retail.header.card.description02.title"
                              )
                            }}
                          </p>
                          <p class="description mb--0">
                            {{
                              $t(
                                "solution.retail.header.card.description02.desc1"
                              )
                            }}
                            <br />
                            {{
                              $t(
                                "solution.retail.header.card.description02.desc2"
                              )
                            }}
                            <br />
                            {{
                              $t(
                                "solution.retail.header.card.description02.desc3"
                              )
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 解决方案 -->
    <section class="rn-section-gap">
      <SectionTitle :title="$t('solution.solutions_title')" description="SOLUTIONS" textAlign="center" />
      <div class="container">
        <RetailFMCGSolution></RetailFMCGSolution>
      </div>
    </section>
    <!-- 客户价值 -->
    <custom-value customState="center" pageLayout="centerFour" :list="list"></custom-value>
    <!-- 方案优势 -->
    <RetailFMCGAdvantage></RetailFMCGAdvantage>
    <!-- 典型案例 -->
    <ClassicCases :classicCasesData="ClassicCasesData" />
  </Layout>
</template>

<script>
import Layout from "@/components/common/Layout";
import SectionTitle from "@/components/elements/sectionTitle/SectionTitle";
import RetailFMCGSolution from './components/retail/RetailFMCGSolution'
import CustomValue from './components/CustomValue.vue'
import RetailFMCGAdvantage from './components/retail/RetailFMCGAdvantage'
import ClassicCases from './components/ClassicCases.vue'

export default {
  name: 'RetailFMCG',
  components: { Layout, SectionTitle, RetailFMCGSolution, CustomValue, RetailFMCGAdvantage, ClassicCases },
  props: {

  },
  data() {
    return {
      list: [
        { title: this.$t('solution.retail.values.tab.tab01') },
        { title: this.$t('solution.retail.values.tab.tab02') },
        { title: this.$t('solution.retail.values.tab.tab03') },
        { title: this.$t('solution.retail.values.tab.tab04') }
      ],
      //产品案例
      ClassicCasesData: [
        {
          // imageBackground: require('@/assets/images/IndustrySolution/ClassicCases/SUMMERGATE_background.png'),
          brandIcon: require('@/assets/images/IndustrySolution/ClassicCases/SUMMERGATE_icon.png'),
        }, {
          // imageBackground: require('@/assets/images/IndustrySolution/ClassicCases/GODIVA_background.png'),
          brandIcon: require('@/assets/images/IndustrySolution/ClassicCases/GODIVA_icon.png'),
        },
        {
          // imageBackground: require('@/assets/images/IndustrySolution/ClassicCases/GODIVA_background.png'),
          brandIcon: require('@/assets/images/IndustrySolution/ClassicCases/fmcg_icon03.png'),
        },
      ]
    }
  },
  methods: {

  }
}
</script>